<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'MenuWrapper',
  components: {},
  data: () => ({}),
  computed: {},
  watch: {},
  mounted() {},
  methods: {}
};
</script>
